import { LOCOfferDeclinedIcon } from "../../assets/icons";

export default function LineOfCreditDeclined() {
  return (
    <div className="cx-flex cx-flex-col cx-items-center cx-justify-center cx-w-full cx-min-h-screen cx-background-radial-gradient">
      <div className="cx-grow cx-w-full cx-max-w-[960px] cx-flex cx-flex-col cx-items-center cx-justify-center">
        <LOCOfferDeclinedIcon className="w-20 h-20 text-[#2F86F6]" />

        <div className="cx-text-text-primary cx-font-bold cx-text-3xl cx-text-center cx-my-2">
          We're sad to see you go!
        </div>

        {/* 3-line centered text */}
        <div className="cx-text-text-secondary cx-text-center cx-mb-10">
          Your application has been successfully rejected. <br />
          If there's anything else you'd like to do or need further assistance,{" "}
          <br />
          feel free to reach out at{" "}
          <a
            href={`mailto:"support@crediblex.io"`}
            className="underline font-medium text-blue-600 hover:text-blue-700 !text-blue-600"
          >
            "support@crediblex.io"
          </a>
        </div>
      </div>
    </div>
  );
}
